import { columnTypes } from '../../constants/globals';

export const tableConfig = () => {
  return {
    columns: [
      {
        key: 'timestamp',
        width: '18%',
        className: 'text-center',
        type: columnTypes.date,
        timestamp: true,
      },
      {
        key: 'principal',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'method',
        width: '12%',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'uri',
        width: '18%',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'referer',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'status',
        width: '12%',
        className: 'text-center',
        type: columnTypes.enum,
        options: [
          { startsWith: '2', color: 'text-success text-center' },
          { startsWith: '4', color: 'text-danger bold-text text-center' },
          { startsWith: '5', color: 'text-danger bold-text text-center' },
        ],
      },
      {
        key: 'timeTaken',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
    ],
  };
};
